<template lang="pug">
  reports-header
</template>

<script>
import ReportsHeader from './ReportsHeader.vue'

export default {
  name: 'FarmReports',

  components: {
    ReportsHeader
  },

  mounted () {
    if (!this.reportFilters) {
      this.setDefaultFilters()
    }
  },

  methods: {
    setDefaultFilters () {
      const filters = {
        farm: { value: this.$route.params.farm_id },
        planned_on_after: { value: new Date().toISOString().substring(0, 10) },
        planned_on_before: { value: new Date().toISOString().substring(0, 10) }
      }
      this.$store.dispatch('setReportFilters', filters)
    }
  },

  computed: {
    reportFilters () {
      return this.$store.getters.reportFilters
    }
  }
}
</script>
